module.exports = __webpack_public_path__ + "img/suggestedarw.00cf2cb6.svg";